<template>
  <div>
    <section class="card-grid">
      <StatCard label="用户总量" value="128" hint="统一查看小程序注册用户规模" />
      <StatCard label="宠物资料数" value="326" hint="集中管理用户侧宠物档案" />
      <StatCard label="今日新增记录" value="86" hint="投喂、健康、环境数据集中排查" />
      <StatCard label="待处理问题" value="19" hint="后续可接告警与客服处理流" />
    </section>

    <section class="panel-grid">
      <div class="panel-card">
        <div class="panel-title">管理重点</div>
        <div class="panel-list">
          <div class="panel-item">先打通用户、宠物、相册和记录数据这条管理链路。</div>
          <div class="panel-item">后续重点补分页筛选、批量处理、操作日志和权限隔离。</div>
          <div class="panel-item">这个后台是内部工具，核心目标是查数据、管数据、处理问题。</div>
        </div>
      </div>

      <div class="panel-card">
        <div class="panel-title">当前联调接口</div>
        <div class="api-chip-row">
          <div class="api-chip">GET /api/health/ping</div>
          <div class="api-chip">POST /api/users/openid/login</div>
          <div class="api-chip">GET /api/pets</div>
          <div class="api-chip">POST /api/pets</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import StatCard from "../components/StatCard.vue"

export default {
  name: "DashboardView",
  components: {
    StatCard
  }
}
</script>

<style scoped>
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.panel-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 16px;
  margin-top: 16px;
}

.panel-card {
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 20px;
  padding: 20px;
}

.panel-title {
  color: #111827;
  font-size: 18px;
  font-weight: 700;
}

.panel-list {
  margin-top: 14px;
}

.panel-item {
  padding: 12px 0;
  border-bottom: 1px solid #eef2f7;
  color: #475569;
  line-height: 1.7;
}

.panel-item:last-child {
  border-bottom: none;
}

.api-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.api-chip {
  padding: 10px 12px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e8edf3;
  color: #334155;
  font-size: 13px;
}
</style>
